import { darken, lighten, PaletteMode } from '@mui/material'

export const adjustColorForTheme = (
  mode: PaletteMode,
  color: string,
  amount: number = 0.2
): string => {
  if (mode === 'dark') {
    return lighten(color, amount)
  }
  return darken(color, amount)
}
